/*
 * Layout for campaign launch area
 */

define(["jquery", "marionette", "./template/campaignScheduleModalTemplate.html"], function (
  $,
  Marionette,
  CampaignScheduleModalTemplate,
) {
  "use strict";

  const CampaignView = {};

  CampaignView.campaignScheduleModalView = Marionette.ItemView.extend({
    template: CampaignScheduleModalTemplate,
    triggers: {
      "click #cancelButton": "cancel",
      "click #scheduleButton": "schedule:campaign",
    },
    onDomRefresh: function () {
      $("#campaignScheduleDatepicker").datepicker();
    },
    getDate: function () {
      return $("#campaignScheduleDatepicker").datepicker("getDate");
    },
    getTime: function () {
      return $("#campaignScheduleTime").val();
    },
    scheduleError: function (errorMessage) {
      this.$el
        .find("#scheduleError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("#scheduleError").html("");
    },
  });

  return CampaignView;
});
